import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-discussionboard-guidelines',
  templateUrl: './discussionboard-guidelines.component.html',
  styleUrls: ['./discussionboard-guidelines.component.scss']
})
export class DiscussionboardGuidelinesComponent implements OnInit {
  form: FormGroup;
  constructor(private router: Router, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      newsTitle: ['', [Validators.required]],
      newsSource: ['', [Validators.required]],
      // attachlink: ['', [Validators.pattern(this.reg)]],
      languages: [''],
      remark: [''],
      date: [new Date()]
    });
  }
  askPage() {
    this.router.navigate(['/discussionboard-ask-page']);
  }

}
